import { createContext, useContext } from "react";

/** @type {React.Context<{ embedded: boolean }>} */
export const AppShellContext = createContext({ embedded: false });

export function useAppShell() {
  return useContext(AppShellContext);
}

export function useIsInAppShell() {
  return Boolean(useContext(AppShellContext)?.embedded);
}
